<app-navbar>
    <h2>{{"COMPANY.TITLE" | translate}}: {{companyData.companyName}}</h2>
</app-navbar>

<div class="main-company-profile-row light-grey-background ptb-60">
    <div class="container">
        <div class="row">
            <div class="col-lg-3">
                <div class="logo-wrapper">
                    <img src="{{companyLogoPath}}" alt="profile image" class="companyLogoImage"/>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="company-main-info">
                    <h3 class="custom-section-title">{{companyData.companyName}}</h3>
                    <div class="top-rating mb-5">
                        <ngb-rating [(rate)]="companyData.rating" [max]="5" class="no-outline" readonly="true">
                            <ng-template let-fill="fill">
                                <span class="star" [class.filled]="fill === 100">&#9733;</span>
                            </ng-template>
                        </ngb-rating>
                        <span class="ratings-number">
                            <span>({{companyData.numberOfReviews}}</span>
                            <span *ngIf="companyData.numberOfReviews === 1"> {{"COMPANY.REVIEW" | translate}})</span>
                            <span *ngIf="companyData.numberOfReviews != 1"> {{"COMPANY.REVIEWS" | translate}})</span>
                        </span>


                    </div>
                    <p class="address-info"><i class="fas fa-map-marker-alt"></i>{{companyData.companyAddress}}</p>
                </div>
                <div *ngIf="isAuthor">
                    <div class="company-edit-profile row">
                        <a routerLink="/editare-companie/{{companyData.id}}"
                           class="round-button orange-background mr-5">{{"COMPANY.EDIT" | translate}}</a>
                        <a routerLink="/adauga-job" class="round-button green-background">{{"COMPANY.JOB_PUBLISH" | translate}}</a>
                    </div>
                </div>


            </div>
            <div class="col-lg-3">
                <div class="social-wrapper">
                    <a href="{{companyFacebook}}" target="_blank" *ngIf="companyFacebook"><i
                            class="icofont-facebook"></i>Facebook</a>
                    <a href="{{companyInstagram}}" target="_blank" *ngIf="companyInstagram"><i
                            class="icofont-instagram"></i>Instagram</a>
                    <a href="{{companyLinkedIn}}" target="_blank" *ngIf="companyLinkedIn"><i
                            class="icofont-linkedin"></i>LinkedIn</a>
                    <a href="{{companyTikTok}}" target="_blank" *ngIf="companyTikTok"><i class="fab fa-tiktok"></i>TikTok</a>
                    <a href="{{companyYouTube}}" target="_blank" *ngIf="companyYouTube"><i class="icofont-youtube"></i>YouTube</a>
                    <a href="{{companyWebsite}}" target="_blank" *ngIf="companyWebsite"><i class="icofont-web"></i>Website</a>
                </div>
            </div>
            <!--            <div class="col-lg-4">-->
            <!--                <div class="row justify-content-center">-->
            <!--                    <div class="col-md-6">-->
            <!--                        <p class="counter-title">Salariati</p>-->
            <!--                        <p class="counter-number">59</p>-->
            <!--                    </div>-->
            <!--                    <div class="col-md-6">-->
            <!--                        <p class="counter-title">Job-uri postate</p>-->
            <!--                        <p class="counter-number">5</p>-->
            <!--                    </div>-->
            <!--                    <div class="col-md-6">-->
            <!--                        <p class="counter-title">Job-uri disponibile</p>-->
            <!--                        <p class="counter-number">17</p>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
        </div>
    </div>
</div>

<div class="about-company-section ptb-80">
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <h3 class="custom-section-title">{{"COMPANY.ABOUT" | translate}}</h3>
                <p></p>
                <div class="company-description" [innerHtml]=companyData.companyDescription></div>
                <div class="company-info">
                    <h3 class="custom-section-title">{{"COMPANY.OTHER" | translate}}</h3>
                    <div class="row">
                        <div class="col-md-6">
                            <p><i class="icofont-barcode"></i><span class="text-semi-bold">{{"COMPANY.FISCAL" | translate}}: </span> {{companyData.fiscalCode}}</p>
                            <p><i class="icofont-location-pin"></i><span class="text-semi-bold">{{"COMPANY.LOCATION" | translate}}: </span>{{companyData.city}}, {{companyData.country}}</p>

                            <p><i class="icofont-briefcase-2"></i><span class="text-semi-bold">{{"COMPANY.TVA" | translate}}: </span>
                                <span *ngIf="companyData.vatCode; else falseVat">{{"COMPANY.YES" | translate}}</span>
                                <ng-template #falseVat>{{"COMPANY.NO" | translate}}</ng-template>
                            </p>
                            <p><i class="icofont-files-stack"></i><span
                                    class="text-semi-bold">{{"COMPANY.DOMANI" | translate}}: </span> {{companyData.activitySector}} </p>
                            <p><i class="icofont-files-stack"></i><span
                                    class="text-semi-bold">{{"COMPANY.SUBDOMANI" | translate}}: </span> {{companyData.companyActivitySubSector}}</p>
                            <p><i class="icofont-building"></i><span class="text-semi-bold">{{"COMPANY.TYPE" | translate}}: </span>
                                <span>{{companyData.companyType | enumTransform}}</span>
                            </p>
                            <p><i class="icofont-people"></i><span
                                    class="text-semi-bold">{{"COMPANY.LEVEL_EMPLY" | translate}}: </span>
                                <!-- <span>{{companyData.companyEmployeesLevel | enumTransform}}</span> -->
                                <span *ngIf="companyData.companyEmployeesLevel==='micro' ">{{"COMPANY.MICRO_EMPLY" | translate}}</span>
                                <span *ngIf="companyData.companyEmployeesLevel==='small' ">{{"COMPANY.SMALL_EMPLY" | translate}}</span>
                                <span *ngIf="companyData.companyEmployeesLevel==='medium' ">{{"COMPANY.MEDIUM_EMPLY" | translate}}</span>
                                <span *ngIf="companyData.companyEmployeesLevel==='big' ">{{"COMPANY.LARGE_EMPLY" | translate}}</span>
                            </p>
                            <p><i class="icofont-coins"></i><span class="text-semi-bold">{{"COMPANY.LEVEL_INCOME" | translate}}: </span>
                                <!-- <span>{{companyData.companyRevenue | enumTransform}}</span> -->
                                <span *ngIf="companyData.companyRevenue==='micro'">{{"COMPANY.MICRO_INCOME" | translate}}</span>
                                <span *ngIf="companyData.companyRevenue==='small'">{{"COMPANY.SMALL_INCOME" | translate}}</span>
                                <span *ngIf="companyData.companyRevenue==='medium'">{{"COMPANY.MEDIUM_INCOME" | translate}}</span>
                                <span *ngIf="companyData.companyRevenue==='big'">{{"COMPANY.LARGE_INCOME" | translate}}</span>
                            </p>
                            <p><i class="icofont-search-user"></i><span class="text-semi-bold">{{"COMPANY.PLANS_CYEAR" | translate}}: </span>
                                <span>{{companyData.employmentThisYear | enumTransform}} {{"COMPANY.PERSON" | translate}}</span>
                            </p>
                            <p><i class="icofont-search-user"></i><span class="text-semi-bold">{{"COMPANY.PLANS_NYEAR" | translate}}: </span>
                                <span>{{companyData.employmentNextYear | enumTransform}} {{"COMPANY.PERSON" | translate}}</span>
                            </p>
                            <p><i class="icofont-search-user"></i><span class="text-semi-bold">{{"COMPANY.PLANS_FAST" | translate}}: </span>
                                <span>{{companyData.employmentEmergencies | enumTransform}} {{"COMPANY.PERSON" | translate}}</span>
                            </p>
                        </div>
                        <!-- <div class="col-md-6">
                            <p><i class="icofont-user-suited"></i><span class="text-semi-bold">Administrator</span></p>
                            <div class="admin-info">
                                <p><span>{{companyData.administratorFirstName | enumTransform}}</span></p>
                                <p><span>{{companyData.administratorLastName | enumTransform}}</span></p>
                                <p><span class="text-semi-bold">Telefon: </span>
                                    <span>{{companyData.administratorTelephone | enumTransform}}</span>
                                </p>
                                <p><span class="text-semi-bold">Email: </span>
                                    <span>{{companyData.administratorEmail | enumTransform}}</span>
                                </p>
                            </div>
                        </div> -->

                    </div>



                    <!--                    <p>Rating-->
                    <!--                        <span>{{companyData.rating}}</span>-->
                    <!--                    </p>-->

                    <!--                    <p>Numar reviews-->
                    <!--                        <span>{{reviewNumbers.number}}</span>-->
                    <!--                    </p>-->

                    <!--                    <span>Company Certifications:-->
                    <!--                        <div class="company-reviews" *ngFor="let item of companyData.companyCertifications | keyvalue">-->
                    <!--                            <p><b>-name: </b> {{item.value.name}}</p>-->
                    <!--                            <p><b>-link: </b> {{item.value.link}}</p>-->
                    <!--                            <p><b>-position: </b> {{item.value.position}}</p>-->
                    <!--                        </div>-->
                    <!--                    </span>-->

                    <!--                    <span>Company Awards:-->
                    <!--                        <div class="company-reviews" *ngFor="let item of companyData.companyAwards | keyvalue">-->
                    <!--                            <p><b>-name: </b> {{item.value.name}}</p>-->
                    <!--                            <p><b>-link: </b> {{item.value.link}}</p>-->
                    <!--                            <p><b>-position: </b> {{item.value.position}}</p>-->
                    <!--                        </div>-->
                    <!--                    </span>-->

                    <!--                    <span>Recommendations:-->
                    <!--                        <div class="company-reviews" *ngFor="let item of companyData.recommendations | keyvalue">-->
                    <!--                            <p><b>-name: </b> {{item.value.name}}</p>-->
                    <!--                            <p><b>-link: </b> {{item.value.link}}</p>-->
                    <!--                            <p><b>-position: </b> {{item.value.position}}</p>-->
                    <!--                        </div>-->
                    <!--                    </span>-->

                    <!--                    <span>Company Articles:-->
                    <!--                        <span *ngFor="let article of companyData.companyArticles">-->
                    <!--                            {{article}}-->
                    <!--                        </span>-->
                    <!--                    </span>-->
                </div>


                <!--Server Response-->
                <div class="row mt-20" *ngIf="formHasBeenSend">
                    <div class="col-12">
                        <app-form-response [serverResponse]='serverResp'>
                            <div class="success-content" *ngIf="serverResp === true">
                                <p class="text-white font-weight-bold mb-0">{{"COMPANY.EVALUATION" | translate}}</p>
                            </div>
                            <div class="error-content" *ngIf="serverResp === false">
                                <div *ngFor="let error of serverErrorMessages">
                                    <p class="text-white font-weight-bold mb-0">{{error}}</p>
                                </div>
                            </div>
                        </app-form-response>
                    </div>
                </div>


                <!--Review Section-->
                <div class="reviews" *ngIf="!formHasBeenSend && isCandidate && !userAlreadyReview">
                    <div class="row">
                        <div class="col-12">
                            <h3 class="custom-section-title mb-10">{{"REVIEW.TITLE" | translate}}</h3>
                            <form (ngSubmit)="onReviewJob(reviewForm)" #reviewForm='ngForm'>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <span class="d-block c-label">{{"REVIEW.GENERAL" | translate}} <span
                                                    class="orange-color">*</span></span>
                                            <ngb-rating [(rate)]="currentRate" [max]="5" class="no-outline">
                                                <ng-template let-fill="fill">
                                                    <span class="star" [class.filled]="fill === 100">&#9733;</span>
                                                </ng-template>
                                            </ngb-rating>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="reviewTitle" class="c-label">{{"REVIEW.TITLE_REV" | translate}} <span
                                                    class="orange-color">*</span></label>
                                            <input class="form-control"
                                                   id="reviewTitle"
                                                   type="text"
                                                   ngModel
                                                   #reviewTitle="ngModel"
                                                   name="reviewTitle"
                                                   required
                                                   minlength = "10"
                                                   (change)="letterCheck(reviewTitle.name, reviewTitle.value)"
                                                   placeholder="Într-o singură propoziție descrie experiența ta. Min 10 caractere.">
                                            <div class="error-msg"
                                                 *ngIf="!reviewTitle.valid && reviewTitle.touched">
                                                {{'VALIDATION.MIN' | translate}}
                                            </div>
                                            <div class="error-msg" *ngIf="reviewTitleFail">{{'VALIDATION.ONLY_LETTERS' | translate}}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="noName" class="d-block c-label">{{"REVIEW.ANONIM" | translate}}</label>
                                            <label for="noName" class="checkbox-container d-inline-block">{{"COMPANY.YES" | translate}}
                                                <input type="checkbox" id="noName"
                                                       name="noName"
                                                       value="false"
                                                       [(ngModel)]="hideName"
                                                >
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12" *ngIf="!hideName">
                                        <div class="form-group">
                                            <label for="name" class="c-label">{{"REVIEW.NAME" | translate}}<span
                                                    class="orange-color">*</span></label>
                                            <input class="form-control"
                                                   id="name"
                                                   type="text"
                                                   name="name"
                                                   required
                                                   ngModel
                                                   #fullName='ngModel'
                                                   (change)="letterCheck(fullName.name, fullName.value)"
                                            >
                                            <div class="error-msg"
                                                 *ngIf="!fullName.valid && fullName.touched">
                                                {{'VALIDATION.REQUIRED' | translate}}
                                            </div>
                                            <div class="error-msg" *ngIf="fullNameFail">{{'VALIDATION.ONLY_LETTERS' | translate}}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="c-label" for="experienceLevel">{{"REVIEW.EXP" | translate}}<span
                                                    class="orange-color">*</span></label>
                                            <select id="experienceLevel"
                                                    class="form-control"
                                                    ngModel
                                                    name="experienceLevel"
                                                    #experienceLevel='ngModel'
                                                    required
                                            >
                                                <option value="" selected disabled hidden> {{"JOBS.OPPTION" | translate}}
                                                </option>
                                                <option value="student" selected>{{"REVIEW.STUDENT" | translate}}</option>
                                                <option value="entry_level">{{"REVIEW.ENTRY_LEVEL" | translate}}</option>
                                                <option value="junior">{{"REVIEW.JUNIOR" | translate}}</option>
                                                <option value="specialist">{{"REVIEW.SPECIALIST" | translate}}</option>
                                                <option value="senior">{{"REVIEW.SENIOR" | translate}}</option>
                                                <option value="executive">{{"REVIEW.EXECUTIVE" | translate}}</option>
                                            </select>

                                            <div class="error-msg"
                                                 *ngIf="!experienceLevel.valid && experienceLevel.touched">
                                                {{'VALIDATION.REQUIRED' | translate}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <label for="proReview" class="c-label">{{"REVIEW.PRO" | translate}}<span
                                                    class="orange-color">*</span></label>
                                            <textarea class="form-control resize-none"
                                                      id="proReview"
                                                      rows="5"
                                                      ngModel
                                                      required
                                                      minlength="10"
                                                      #proReview="ngModel"
                                                      name="proReview"
                                            ></textarea>
                                            <div class="error-msg"
                                                 *ngIf="!proReview.valid && proReview.touched">
                                                {{'VALIDATION.MIN' | translate}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <label for="contraReview" class="c-label">{{"REVIEW.CONTRA" | translate}}<span class="orange-color">*</span></label>
                                            <textarea class="form-control resize-none"
                                                      id="contraReview"
                                                      rows="5"
                                                      ngModel
                                                      required
                                                      minlength="10"
                                                      #contraReview="ngModel"
                                                      name="contraReview"
                                            ></textarea>
                                            <div class="error-msg"
                                                 *ngIf="!contraReview.valid && contraReview.touched">
                                                {{'VALIDATION.MIN' | translate}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <label for="department" class="c-label">{{"JOBS.DEPARTMENT" | translate}}</label>
                                            <ng-select2 [data]="departments"
                                                        [options]="singleOption"
                                                        ngModel
                                                        id="department"
                                                        name="department"
                                            >
                                            </ng-select2>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <div class="form-group">
                                            <label for="salary" class="c-label">{{"REVIEW.SALARY" | translate}}</label>
                                            <div class="input-group">
                                                <input id="salary"
                                                       type="number"
                                                       class="form-control"
                                                       min="0"
                                                       ngModel
                                                       name="salary"
                                                       #salary="ngModel">
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text currency-box">€/{{"REVIEW.MONTH" | translate}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!--Submit Button-->
                                        <div class="text-center">
                                            <button type="submit"
                                                    class="green-button w-100 d-block border-0"
                                                    [disabled]="!reviewForm.valid"
                                            >{{"REVIEW.POST" | translate}}</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <h3 class="custom-section-title">{{"REVIEW.ACTIVE_JOBS" | translate}}</h3>
                <p *ngIf="jobs.length === 0">{{"REVIEW.NO_ACTIVE" | translate}}</p>


                <div class="company-jobs mb-5" *ngFor="let job of jobs  | slice:0:3">

                    <!--Right Corner Content-->
                    <div class="job-type-and-date">
                                <span class="type-job-badge px-3 py-2"
                                      [ngClass]="{
                                       'green-background': job.workType === 'volunteer',
                                       'blue-background': job.workType === 'practice',
                                       'yellow-background': job.workType === 'internship',
                                       'tryan-purple': job.workType === 'project',
                                       'orange-background': job.workType === 'temporary',
                                       'verdigris': job.workType === 'part_time',
                                       'purple-heart ': job.workType === 'full_time',
                                       'darkgreen-background': job.workType === 'remote'}"
                                >{{job.workType | enumTransform}}</span>
                        <span class="post-date d-block">
                            {{"JOBS.DATE" | translate}}
                            {{job.jobPostingDate | date:"dd-MM-yyyy"}}
                        </span>
                    </div>

                    <!--Details-->
                    <div class="row ml-3">
                        <!--Logo-->
                        <div class="col-md-8 col-12 my-5">
                            <div class="photo-box">
                                <a routerLink="/job/{{job.id}}">
                                    <img class="job-logo img-fluid" src="{{job.photoPath}}" alt="Job Logo">
                                </a>
                            </div>
                        </div>
                        <!--Job Title-->
                        <div class="col-md-8 col-12 mb-3">
                            <a routerLink="/job/{{job.id}}">
                                <h5 class="custom-section-title">{{job.jobTitle}}</h5>
                            </a>
                        </div>
                    </div>

                    <!--Location-->
                    <div class="job-location">
                        <i class="icofont-location-pin"><span class="ml-2">{{job.country}} - {{job.city}}</span></i>
                    </div>
                </div>

                <div class="jobs-buttons-wrapper">
                    <a routerLink="/adauga-job" class="round-button green-background" *ngIf="isAuthor">{{"COMPANY.ADD_JOB" | translate}}</a>
                    <a routerLink="/joburi/{{companyData.id}}" class="round-button yellow-background"
                       *ngIf="jobs.length > 0">{{"COMPANY.ALL_JOBS" | translate}}</a>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="reviews-container pt-20">
                <h3 class="custom-section-title">{{"COMPANY.REVIEWS" | translate | titlecase}}:</h3>
                <div class="company-reviews" *ngFor="let review of reviews">
                    <div class="single-company-review">
                        <h2><b>{{review['userName']}} : </b>{{review['reviewTitle']}}</h2>
                        <ngb-rating [(rate)]="review['rating']" [max]="5" class="no-outline" readonly="true">
                            <ng-template let-fill="fill">
                                <span class="star" [class.filled]="fill === 100">&#9733;</span>
                            </ng-template>
                        </ngb-rating>

                        <p><b>Pro</b></p>
                        <p>{{review['proReview']}}</p>

                        <p><b>Contra</b></p>
                        <p>{{review['contraReview']}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
